import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Clear hash from URL immediately
    try {
      window.history.replaceState(null, "", window.location.pathname);
    } catch (_) {}

    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        await refresh();
        toast.success("Login Google berhasil");
        nav("/", { replace: true });
      } catch (e) {
        const detail = e.response?.data?.detail || "Login Google gagal";
        toast.error(typeof detail === "string" ? detail : "Login Google gagal");
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#f7f9f7]">
      <div className="text-sm text-slate-500" data-testid="google-callback-processing">
        Memproses login Google...
      </div>
    </div>
  );
}
